import { render, staticRenderFns } from "./RightPaymentSection.vue?vue&type=template&id=487c693e&scoped=true"
import script from "./RightPaymentSection.vue?vue&type=script&lang=ts"
export * from "./RightPaymentSection.vue?vue&type=script&lang=ts"
import style0 from "./RightPaymentSection.vue?vue&type=style&index=0&id=487c693e&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487c693e",
  null
  
)

export default component.exports